// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.studio-feed-row[data-v-14d5ec26] {
  width: 100%;
}
.studio-feed-row.size-to-card[data-v-14d5ec26] {
  width: fit-content;
}
.studio-feed-row.size-to-card.fill-card[data-v-14d5ec26] {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/dynamic-component-editor/standard-elements/StudioFeedRowItem.vue","webpack://./StudioFeedRowItem.vue"],"names":[],"mappings":"AAEA;EACE,WAAA;ACDF;ADIA;EACE,kBAAA;ACDF;ADIA;EACE,WAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.studio-feed-row {\n  width: 100%;\n}\n\n.studio-feed-row.size-to-card {\n  width: fit-content;\n}\n\n.studio-feed-row.size-to-card.fill-card {\n  width: 100%;\n}\n",".studio-feed-row {\n  width: 100%;\n}\n\n.studio-feed-row.size-to-card {\n  width: fit-content;\n}\n\n.studio-feed-row.size-to-card.fill-card {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
